
export default class DefaultAirport {
    "airportCode": string = "";
    "airportDescription": string = "";
    "isBase": boolean;
} 